/**
 * Created by WangPing on 2020/5/14.
 */
/**
 *@滚动函数
 *@innerBox 内层盒子DOM
 *@outerBox 外层盒子DOM
 *@direction 方向，只支持两种，top:向上滚动，内层盒子width:100%;height:auto,left:向左滚动，内层盒子width:auto;height:100%;
 *@time 滚动时间，滚动时间短，且滚动距离短，则为持续滚动效果，滚动时间长，且滚动距离长，则为每隔 time 时间 滚动一次效果
 *@step 滚动距离，可传入DOM获取高度
 *@author WangPing
 *@date 2020-05-19
 */
export default class Roll {
    constructor(opts) {
        this.innerBox = opts.innerBox; // 内层包含滚动元素的高度
        this.outerBox = opts.outerBox; //外层可视区域高度
        this.direction = opts.direction;
        this.time = opts.time;
        this.step = opts.step;
        this.copyCount = 2;// 要复制的个数
        this.init();
        this.roll = this.roll.bind(this)
        this.startRoll = this.startRoll.bind(this)
        this.stopRoll = this.stopRoll.bind(this)
    }
    init(){
        // 获取图片元素
        this.elemHtml = this.innerBox.innerHTML;
        // 获取复制图片前图片的高度
        this.innerBoxHeight = this.innerBox.offsetHeight;
        // 获取复制图片前的宽度
        this.innerBoxWidth = this.innerBox.offsetWidth;
        // 复制2个，防止单张图横图情况下底下留有空白问题；（向上滚动的竖图多复制一个即可，复制三个防止向上滚动横图底下留白）
        for(let i = 0;i<this.copyCount;i++){
            this.innerBox.innerHTML += this.elemHtml;
        }
        // 向上滚或者向左滚动都是每次减对应长度
        this.speed = -parseFloat(this.step);
    }
    reInit(){
        //这里除以复制的个数 + 本身的个数 ，这里为3
        this.innerBoxHeight = this.innerBox.offsetHeight/(this.copyCount+1);
        this.innerBoxWidth = this.innerBox.offsetWidth/(this.copyCount+1);
    }
    roll(){
        // 不同的方向设置不同的样式属性，获取top、height等值不要提前定义出来， 就在这里重新获取
        switch (this.direction) {
            case "top":
                // 如果滚动的盒子的top值超出元素的高度，则置为0
                // 当取余之后大于5则向上取整，小于5向下取整，防止空行
                let lineNum = 0;
                if((this.innerBoxHeight%this.step)>5){
                    lineNum = Math.ceil(this.innerBoxHeight / this.step);
                }else{
                    lineNum = Math.floor(this.innerBoxHeight / this.step);
                }
                if (lineNum > 1) { // 当行数大于等于1行时，开始滚动，否则不滚动
                    if(Math.abs(this.outerBox.offsetTop) > this.innerBoxHeight){
                        this.outerBox.style.top = 0;
                    }else{
                        this.outerBox.style.top = this.outerBox.offsetTop + this.speed + 'px';
                    }
                }else{
                    clearInterval(this.scrollTimer)
                }
                break;
            case "left":
                // 如果滚动的盒子的left超出元素的宽度，则置为0
                if(Math.abs(this.outerBox.offsetLeft) >= this.innerBoxWidth){
                    this.outerBox.style.left = 0;
                }else{
                    this.outerBox.style.left = this.outerBox.offsetLeft + this.speed + 'px';
                }
                break;
            default:
                // 默认向上滚动，如果滚动的盒子的top超出元素的高度，则置为0
                if(Math.abs(this.outerBox.offsetTop) >= this.innerBoxHeight){
                    this.outerBox.style.top = 0;
                }else{
                    this.outerBox.style.top = this.outerBox.offsetTop + speed + 'px';
                }
        }
    }
    stopRoll(){
        clearInterval(this.scrollTimer)
    }
    startRoll(){
        this.stopRoll();
        this.scrollTimer = setInterval(this.roll,this.time)
    }
}